import React from 'react';
import { Button, Icon } from 'antd';

export function GenericButton({ icon, children, label, filled, ...props }) {
  return (
    <Button {...props}>
      {icon && <Icon type={icon} theme={filled} />}
      {label}
      {children}
    </Button>
  );
}
